module.exports = __webpack_public_path__ + "img/137.50b2117c.jpg";